export default "__VITE_ASSET__1e9f27f6__"